import {
  ButtonContent,
  buttonStyles,
  type ButtonStyleProps
} from '../Button/Button';
import Link from 'next/link';
import type { ComponentProps, ReactNode } from 'react';

export interface ButtonLinkProps
  extends Omit<ComponentProps<typeof Link>, 'className'>,
    ButtonStyleProps {
  icon?: ReactNode;
  children?: ReactNode;
}

/**
 * Navigation that looks like a button: a real link (opens in a new tab,
 * shows the URL), styled exactly like `Button`.
 */
const ButtonLink = ({
  variant,
  size,
  className,
  icon,
  children,
  ...props
}: ButtonLinkProps) => (
  <Link className={buttonStyles({ variant, size, className })} {...props}>
    <ButtonContent variant={variant} icon={icon}>
      {children}
    </ButtonContent>
  </Link>
);

export default ButtonLink;
